import { createResource } from './resource-loader.js';

export { createResource, scheduleResourcePreload, type Resource } from './resource-loader.js';

/** Each browser application owns its resource promises independently of route lifetimes. */
export function createGameplayLoader() {
  return {
    runtime: createResource(() => import('./index.js')),
    renderer: createResource(async () => {
      const { preloadRenderer } = await import('@cardforest/renderer');
      await preloadRenderer();
    }),
    board: createResource(() => import('./react/index.js')),
  };
}
